import { Icon } from '@iconify/react';
import { Button } from '@/components/shadcn/button';
import { Card } from '@/components/shadcn/card';

interface PickleballFeedbackDialogProps {
  open: boolean;
  icon: string;
  title: string;
  message: string;
  onClose: () => void;
}

export default function PickleballFeedbackDialog({
  open,
  icon,
  title,
  message,
  onClose,
}: PickleballFeedbackDialogProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
      role="presentation"
      onClick={onClose}
    >
      <Card
        role="dialog"
        aria-modal="true"
        aria-labelledby="pickleball-feedback-title"
        className="w-full max-w-sm rounded-3xl border-0 p-6 text-center shadow-lg"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-[#FFF1EC] text-[#FC480D]">
          <Icon icon={icon} className="h-7 w-7" />
        </div>
        <h2 id="pickleball-feedback-title" className="text-lg font-extrabold text-[#0E1726]">
          {title}
        </h2>
        <p className="mt-2 text-sm text-gray-500">{message}</p>
        <Button
          type="button"
          className="mt-5 h-12 w-full rounded-full bg-[#FC480D] font-bold text-white hover:bg-[#D83B08]"
          onClick={onClose}
        >
          Mengerti
        </Button>
      </Card>
    </div>
  );
}
